export { default as NewAdsSection } from './NewAdsSection';



// WEBPACK FOOTER //
// ./src/containers/ModulePage/NewAdsSection/index.ts